// extracted by mini-css-extract-plugin
export default {"dialog_modal":"styles_dialog_modal__DGqDW","titleBox":"styles_titleBox__90YiQ"};